import { api } from './api';

export const priceLogApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSellerPriceLogs: builder.query({
      query: ({ sellerId, ...params }) => ({
        url: `/price-logs/seller/${sellerId}`,
        params,
      }),
      providesTags: (result, error, { sellerId }) => [
        { type: 'PriceLog', id: sellerId },
        { type: 'PriceLog', id: 'LIST' },
      ],
    }),
    getCatalogPriceLogs: builder.query({
      query: ({ catalogId, ...params }) => ({
        url: `/price-logs/catalog/${catalogId}`,
        params,
      }),
      providesTags: (result, error, { catalogId }) => [{ type: 'PriceLog', id: catalogId }],
    }),
  }),
});

export const { useGetSellerPriceLogsQuery, useGetCatalogPriceLogsQuery } = priceLogApi;
